import React from "react";

function MovingtoLives() {
  return (
    <div class="idocs-content">
      <div class="container">
        <div class="row">
          <div class="col-md-8">
            <section id="idocs_content" class="mt-20 mb-20">
              <h1> Moving to LIVE</h1>
              <hr />
            </section>

            <ul>
              <li>
              To go LIVE, the merchant should first complete the integration on the TEST environment; Post giving successful integration, the merchant should give a mail confirmation to the integration team mentioning the details of the transaction done on the TEST environment below. 
              </li>

              <p>⇒ <b> Order Number, Amount, Transaction AG REF, Transaction PG REF, Transaction Status, Transaction Date and Time</b></p>
              <li>
              The merchant should provide their referral URLs from which LIVE payment requests would be sent so the same can be whitelisted on <b>SafexPay</b> while moving the merchant setup to the production environment. 
              </li>
              <li>
              <b>Safexpay</b> team then initiates the processing and moves the merchant to the LIVE system. 
              </li>
            </ul>
          </div>
          <div class="col-md-4"></div>
        </div>
      </div>
    </div>
  );
}
export default MovingtoLives;
